/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import BarraPc from "./BarraPc";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import BarraCell from "./BarraCell";
import {useIrRuta} from "../../Utilidades/useIrRuta";


const Barra = () => {
    const {sCell, masSM} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: theme.palette.primary.main,

                }}
            >

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: 3, color: '#ffffff60', pt: 0.5, pb: 0.4}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >

                            <Grid
                                onClick={() => window.location.href = 'tel:+573015243727'}
                                container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 14, cursor: 'pointer'}}>
                                    {sCell ? '+57 301 524 3727' : 'linea telefonico: +57 301 524 3727'}
                                </Typography>
                            </Grid>

                            <Grid
                                onClick={() => window.location.href = 'mailto:soluciondeconflictosparalapazc@gmail.com'}
                                container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                                <Typography sx={{fontSize: 14, cursor: 'pointer'}}>
                                    {sCell ? "mail: soluciond..." : 'mail: soluciondeconflictosparalapazc@gmail.com'}
                                </Typography>
                            </Grid>

                        </Grid>
                    </Grid>


                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                {masSM ?
                    <BarraPc/>
                    :
                    <BarraCell/>
                }


            </Grid>


        </Grid>
    )

}
export default Barra